module.exports = __webpack_public_path__ + "img/Rectangle 556.38be53e2.png";